import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { EVENT_TYPES } from '../constants';

const getEventMeta = (type) => EVENT_TYPES.find(t => t.value === type) || EVENT_TYPES[0];

export default function CalendarView({ events, calMonth, setCalMonth, setDetailEvent, onDateClick }) {
  const { year, month } = calMonth;
  const monthName = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'][month];
  const today = new Date();

  const firstDay = new Date(year, month, 1);
  const startOffset = (firstDay.getDay() + 6) % 7; // Mon=0
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < 42; i++) {
    cells.push(i - startOffset + 1);
  }

  const eventsByDay = {};
  events.forEach(ev => {
    const key = ev.date;
    if (!eventsByDay[key]) eventsByDay[key] = [];
    eventsByDay[key].push(ev);
  });

  const WEEKDAYS_SHORT = ['Mo','Di','Mi','Do','Fr','Sa','So'];

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <IconButton size="small" onClick={() => setCalMonth(cm => {
          const d = new Date(cm.year, cm.month - 1, 1);
          return { year: d.getFullYear(), month: d.getMonth() };
        })}><ChevronLeftIcon /></IconButton>
        <Typography fontWeight={700} variant="subtitle1">{monthName} {year}</Typography>
        <IconButton size="small" onClick={() => setCalMonth(cm => {
          const d = new Date(cm.year, cm.month + 1, 1);
          return { year: d.getFullYear(), month: d.getMonth() };
        })}><ChevronRightIcon /></IconButton>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', mb: 0.5 }}>
        {WEEKDAYS_SHORT.map(d => (
          <Typography key={d} variant="caption" fontWeight={700} color="text.secondary"
            sx={{ textAlign: 'center', fontSize: 11 }}>{d}</Typography>
        ))}
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' }}>
        {cells.map((dayNum, idx) => {
          const inMonth = dayNum >= 1 && dayNum <= daysInMonth;
          const mm = String(month + 1).padStart(2, '0');
          const dd = String(dayNum).padStart(2, '0');
          const dateKey = `${year}-${mm}-${dd}`;
          const dayEvents = inMonth ? (eventsByDay[dateKey] || []) : [];
          const isToday = inMonth && today.getFullYear() === year && today.getMonth() === month && today.getDate() === dayNum;

          return (
            <Box key={idx} sx={{ minHeight: 70, bgcolor: inMonth ? '#fff' : '#f9f9f9',
              border: '1px solid #e8eef5', borderRadius: 1, p: '4px', overflow: 'hidden',
              opacity: inMonth ? 1 : 0.35 }}>
              <Typography variant="caption" fontWeight={isToday ? 900 : 400}
                onClick={() => inMonth && onDateClick && onDateClick(dateKey)}
                sx={{ display: 'inline-block', width: 20, height: 20, borderRadius: '50%', lineHeight: '20px',
                  textAlign: 'center', mb: '2px', fontSize: 12,
                  bgcolor: isToday ? '#0D47A1' : 'transparent',
                  color: isToday ? '#fff' : inMonth ? 'text.primary' : 'text.disabled',
                  cursor: inMonth && onDateClick ? 'pointer' : 'default',
                  '&:hover': inMonth && onDateClick ? { bgcolor: isToday ? '#1565C0' : '#E3F2FD' } : {} }}>
                {inMonth ? dayNum : ''}
              </Typography>
              {dayEvents.slice(0, 2).map(ev => {
                const meta = getEventMeta(ev.type);
                return (
                  <Box key={ev._key || ev.id} onClick={() => setDetailEvent(ev)}
                    sx={{ fontSize: 10, lineHeight: 1.3, px: '4px', py: '2px', mb: '2px', borderRadius: 1,
                      bgcolor: `${meta.color}20`, color: meta.color, fontWeight: 600,
                      cursor: 'pointer', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                      '&:hover': { bgcolor: `${meta.color}40` } }}>
                    {ev.name}
                  </Box>
                );
              })}
              {dayEvents.length > 2 && (
                <Typography variant="caption" sx={{ fontSize: 9, color: 'text.secondary', pl: '4px' }}>
                  +{dayEvents.length - 2}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
